import { useState, useEffect } from "react";
import NiceModal, { useModal, bootstrapDialog } from "@ebay/nice-modal-react";
import BootstrapModal from "react-bootstrap/Modal";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import React from "react";
import { toast } from "react-toastify";
import { instance } from "../axios";
import Form from 'react-bootstrap/Form';
import { UiSelect, UiInput, UiTextArea, BgLoader, UiButton, OverlayLoader } from "../ui";



const SendWA = NiceModal.create(
  ({ type, contacts, date }) => {
    const [state, setState] = useState({ count: 0 });
    const modal = useModal();

    const schema = yup.object().shape({
      wa_msg: yup.string().required("Message is required"),

    }, []);
    const {
      register,
      handleSubmit,
      control,
      unregister,
      formState: { errors },
      reset,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const onSubmitHandler = async (data) => {
      SaveTag(data);
      //reset();
    };
    var SaveTag = (e) => {
      setState({ ...state, loader: true });
      const formData = new FormData();

      // Append other form fields (text, number, etc.)
      for (const key in e) {
        if (key === "file") {
          // Append the file to FormData
          formData.append(key, e[key][0]); // e[key][0] to get the first selected file
        } else {
          formData.append(key, e[key]);
        }
      }

      // Append the JSON data as a string
      formData.append("type", type);
      formData.append("contacts", JSON.stringify(contacts));
      instance({
        method: "post",
        url: "/send_wa",
        data: formData,
      })
        .then(function (response) {
          setState({ ...state, loader: false });
          if (response.data.status == "error") {
            toast(response.data.msg, { type: "error" });
          }
          if (response.data.status == "success") {
            toast(response.data.msg, { type: "success" });
            modal.resolve({ resolved: true });
            modal.hide();
          }
        })
        .catch(function (response) { });
    };


    const fetchData = () => {
      instance
        .get("/get_template?type=" + type)
        .then(function (response) {
          setState(response.data)
          reset(response.data.template)
        })
        .catch(function (error) { })
        .then(function () { });
    }



    useEffect(() => {
      fetchData()
    }, []);



    const handleHide = () => {
      modal.hide();
    }




    return (
      <BootstrapModal {...bootstrapDialog(modal)} onHide={() => handleHide()}>
        <BootstrapModal.Header closeButton>
          <BootstrapModal.Title>Send Message</BootstrapModal.Title>
        </BootstrapModal.Header>
        <OverlayLoader visible={state.loader} />
        <BootstrapModal.Body>
          {state.status ?
            <form id="waform" onSubmit={handleSubmit(onSubmitHandler)}>

              <UiTextArea

                label="WhatsApp Message"
                name="wa_msg"
                message={errors.wa_msg?.message}
                {...register("wa_msg")}
              />

              {type == 'general' &&
                <>
                  <p>##account##, ##contact_person##</p>

                  <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Select File</Form.Label>
                    <Form.Control name="file" accept=".pdf,.jpg,.jpeg,.png,.gif,.mov,.mp4" type="file" {...register("file")} />
                    <Form.Text className="text-danger">
                      {errors.file?.message}
                    </Form.Text>
                  </Form.Group>
                </>
              }

              <input type="hidden" value={date} name="date" {...register("date")} />
              <UiButton className="btn btn-primary" type="submit" title="Send" />

            </form>
            : <BgLoader />}
        </BootstrapModal.Body>

      </BootstrapModal>
    );
  }
);

export default SendWA;
